import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import client from '../api/client';

const AccountContext = createContext(null);

export const AccountProvider = ({ children }) => {
  const { user, activeAccountId } = useAuth();
  const [activeAccount, setActiveAccount] = useState(null);
  const [loading,        setLoading]       = useState(true);

  useEffect(() => {
    if (!user || !activeAccountId) {
      setActiveAccount(null);
      setLoading(false);
      return;
    }

    if (user.role === 'owner' || user.role === 'platform_admin') {
      if (!localStorage.getItem('dx_active_account')) {
        setActiveAccount({ id: activeAccountId, type: 'platform', status: 'active', name: 'Digital Xtension' });
        setLoading(false);
        return;
      }
    }

    setLoading(true);
    client.get(`/api/accounts/${activeAccountId}`)
      .then(({ data }) => setActiveAccount(data))
      .catch(() => {
        const type = ['owner', 'platform_admin'].includes(user.role)
          ? 'platform'
          : ['agency_admin', 'agency_user'].includes(user.role)
            ? 'agency'
            : 'sub';
        setActiveAccount({ id: activeAccountId, type, status: 'active' });
      })
      .finally(() => setLoading(false));
  }, [activeAccountId, user?.id, user?.role]); // eslint-disable-line

  const accountType  = activeAccount?.type  || 'sub';
  const isWhiteLabel = activeAccount?.plan?.features?.white_label === true;
  const hasAI         = activeAccount?.plan?.features?.ai === true;
  const isPlatform   = accountType === 'platform';
  const isAgency     = accountType === 'agency';
  const isSub        = accountType === 'sub';

  return (
    <AccountContext.Provider value={{
      activeAccount, loading,
      accountType, isWhiteLabel, hasAI,
      isPlatform, isAgency, isSub,
    }}>
      {children}
    </AccountContext.Provider>
  );
};

export const useAccount = () => {
  const ctx = useContext(AccountContext);
  if (!ctx) throw new Error('useAccount must be used within AccountProvider');
  return ctx;
};
